<div class="_dialog-title">
	<mat-icon svgIcon="logo" class="mr-2"></mat-icon>
	<span>{{'nutritional_info' | translate}}</span>
</div>
<div class="_dialog-content scroll-y" style="max-height: calc(100vh - 200px);">
	@if (this.data.attributes) {
		<div class="d-flex align-items-center flex-wrap mb-3" style="gap: 10px;">
			@for (attr of this.data.attributes; track $index) {
				<img [src]="attr.icon" alt="Nutrition icon" aria-hidden="true" class="nutrition-icon" style="height: 50px">
			}
		</div>
	}
	<p [innerHTML]="this.data.info"></p>
</div>
<div class="_bottom-actions">
	<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="dialogRef.close()">{{'continue' | translate}}</button>
</div>

